import { TruncateDirective } from 'shared';
import { booleanAttribute, Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ThemedIconComponent } from '../themed-icon/themed-icon.component';

@Component({
  selector: 'ocp-icon-label',
  imports: [TranslatePipe, ThemedIconComponent, TruncateDirective],
  template: `
    <div class="icon-label">
      @if (iconSrc() && iconPosition() === 'left') {
        <button
          type="button"
          class="icon-label__icon-btn"
          [attr.aria-label]="iconAriaLabel() || null"
          (click)="iconClick.emit($event)"
        >
          <ocp-themed-icon class="icon-label__icon" [name]="iconName()" [size]="12" />
        </button>
      }
      @if (label()) {
        <span ocpTruncate [minWidth]="minWidth()" [maxWidth]="maxWidth()">
          @if (bold()) {
            <b> {{ label() | translate }}</b>
          } @else {
            {{ label() | translate }}
          }
        </span>
      }
      @if (iconSrc() && iconPosition() === 'right') {
        <button
          type="button"
          class="icon-label__icon-btn"
          [attr.aria-label]="iconAriaLabel() || null"
          (click)="iconClick.emit($event)"
        >
          <ocp-themed-icon class="icon-label__icon" [name]="iconName()" [size]="12" />
        </button>
      }
    </div>
  `,
  styles: `
    .icon-label {
      display: flex;
      gap: 5px;
      align-items: center;
    }

    .icon-label__icon-btn {
      display: inline-flex;
      align-items: center;
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      line-height: 0;
    }

    :host(.page-title) {
      font-family: Inter, sans-serif;
      font-size: var(--font-size-2xl);
      font-weight: 400;
      line-height: normal;
    }

    @media (max-width: 768px) {
      :host(.page-title) {
        font-size: var(--font-size-base);
      }
    }
  `,
})
export class IconLabelComponent {
  readonly bold = input(false, { transform: booleanAttribute });
  readonly iconPosition = input<'left' | 'right'>('left');
  readonly label = input<string>('');
  readonly iconSrc = input<string | undefined>(undefined);
  readonly minWidth = input<string | undefined>(undefined);
  readonly maxWidth = input<string | undefined>(undefined);
  readonly iconAriaLabel = input<string>('');
  readonly iconClick = output<Event>();

  protected readonly iconName = computed(() => {
    const src = this.iconSrc();
    return src?.split('/').pop() ?? src ?? '';
  });
}
